// how many capabilites to retrieve in one swell foop.
// the default stripes limit is too small but it doesn't feel like
// raising that value application-wide is appropriate.
export const CAPABILITES_LIMIT = 5000;
